"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentSortFieldToJSON = exports.ExperimentSortFieldFromJSONTyped = exports.ExperimentSortFieldFromJSON = exports.ExperimentSortField = void 0;
/**
 * Field by which to sort list of experiments
 * @export
 */
exports.ExperimentSortField = {
    CreatedAt: 'CREATED_AT',
    Name: 'NAME',
    Status: 'STATUS',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE'
};
function ExperimentSortFieldFromJSON(json) {
    return ExperimentSortFieldFromJSONTyped(json, false);
}
exports.ExperimentSortFieldFromJSON = ExperimentSortFieldFromJSON;
function ExperimentSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ExperimentSortFieldFromJSONTyped = ExperimentSortFieldFromJSONTyped;
function ExperimentSortFieldToJSON(value) {
    return value;
}
exports.ExperimentSortFieldToJSON = ExperimentSortFieldToJSON;
